import { Button, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import "./InitialFormComponent.scss";
import { IInitialFormProps } from "./InitialFormInterfaces.types";
import { useNavigate } from "react-router";
import userDataService from "store/UserData/UserDataService";
import { useSelector } from "react-redux";
import { StorageInterface } from "store/StorageInterface";

function InitialFormComponent(props: IInitialFormProps) {
  const userData = useSelector((state: StorageInterface) => { return state.userDataSlice; });
  const params = new URLSearchParams(window.location.search);
  const [userForm] = Form.useForm();

  const [disabled, setDisabled] = useState(true);

  let navigate = useNavigate();

  const navigateTo = () => {
    navigate('/opciones/');
  };

  const name = userData.fullname && userData.fullname !== '' ? userData.fullname : params.get('name')
  const email = userData.email && userData.email !== '' ? userData.email : params.get('mail')

  useEffect(() => {
    if (name?.length > 0 && email?.length > 0) {
      setDisabled(false);
    }
  })

  const validationErrors = () => {
    let undef = Object.values(userForm.getFieldsValue()).includes(undefined);
    let empty = Object.values(userForm.getFieldsValue()).includes('');
    setDisabled(!(!undef && !empty));
  }
  const onFinish = (values: any) => {
    userDataService.setUserData(values);
    navigateTo();
  };

  const onFinishFailed = () => {
    console.error('datos incorrectos !!!');
  };

  return (
    <>
      <Form
        form={userForm}
        name={'userData'}
        layout="vertical"
        initialValues={{ requiredMarkValue: false }}
        onValuesChange={validationErrors}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        requiredMark={false}
        autoComplete="off"
      >
        <Form.Item
          name='fullname'
          className="InitialForm"
          initialValue={name}
          label="Nombre"
          required={true}
          rules={[{ required: true, message: 'El nombre es requerido' }, { type: 'string', min: 3, max: 25, pattern: new RegExp(/^[A-Za-z ÑñÁáÉéÍíÓóÚú`\\\\]+$/i), message: 'El nombre debe escribirse correctamente' }]}
        >
          <Input placeholder="Juan" />
        </Form.Item>
        <Form.Item
          name='email'
          className="InitialForm"
          label="Email"
          initialValue={email}
          //hasFeedback
          rules={[{
            required: true,
            message: 'El email es requerido'
          }, {
            type: 'email',
            min: 5,
            message: 'Debe especificar su email correctamente',
            warningOnly: false
          },
          ]}
          validateTrigger={'onChange'}
        >
          <Input placeholder="usuario@correo.cl" />
        </Form.Item>
        <Form.Item>
          <div className="NextStepBtn InitialForm next-btn-padding">
            <Button block onClick={() => { }} disabled={disabled} className="first-next-btn" htmlType="submit"> Siguiente </Button>
          </div>
        </Form.Item>
        {
          props.alert && <div style={{display: 'flex', border: '1px solid #FFE6BA', background: '#FFF7E8', borderRadius: '10px', padding: '4px 8px', marginTop: '24px'}}>
            <div style={{marginTop: '4px'}}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM6.5 3.625C6.5 3.55625 6.55625 3.5 6.625 3.5H7.375C7.44375 3.5 7.5 3.55625 7.5 3.625V7.875C7.5 7.94375 7.44375 8 7.375 8H6.625C6.55625 8 6.5 7.94375 6.5 7.875V3.625ZM7 10.5C6.80374 10.496 6.61687 10.4152 6.47948 10.275C6.3421 10.1348 6.26515 9.9463 6.26515 9.75C6.26515 9.5537 6.3421 9.36522 6.47948 9.225C6.61687 9.08478 6.80374 9.00401 7 9C7.19626 9.00401 7.38313 9.08478 7.52052 9.225C7.6579 9.36522 7.73485 9.5537 7.73485 9.75C7.73485 9.9463 7.6579 10.1348 7.52052 10.275C7.38313 10.4152 7.19626 10.496 7 10.5Z"
                  fill="#FFAC1A"></path>
              </svg>
            </div>
            <p style={{margin: '0 0 0 10px', color: '#262626', fontSize: '12px', lineHeight: '20px'}}>
              Tu email debe estar <strong>correctamente ingresado</strong> para recibir tu descuento al final de la simulación.
              Al utilizar el Simulador aceptas recibir comunicaciones comerciales de Autofact.
              Puedes desuscribirte cuando quieras.</p>
          </div>
        }
      </Form>
    </>
  );
}

InitialFormComponent.defaultProps = {
  text: "Siguiente",
  className: "",
  btnClassName: "",
  alert: false,
};

export default InitialFormComponent;
